<template>
  <div>
    <p class="f-Overpass f-18 f-w-500 text center">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel quas facere
      eos modi quidem voluptatem totam, corrupti sed nulla sunt illum, nisi
      voluptate aut sit assumenda! Commodi quod hic quaerat unde amet quidem
      labore similique qui nesciunt ducimus molestiae distinctio esse neque,
      magnam dolore, totam quisquam voluptate. Voluptatibus, explicabo sequi.
    </p>
  </div>
</template>

<script>
export default {
  name: "componentExample", // untuk memudahkan, name ini samakan saja dengan nama file componentnya
};
</script>
